import React from 'react';
import { connect } from 'react-redux';

import { loadsTabModes } from '@reducers/selectors/loads/loadsTabModes';
import { APP_TYPES } from '@config';
import {
  setDesignLoadsDesignValue,
  setDesignLoadsCharacteristicsValue
} from '@reducers/selectors/design/actions';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { setActiveCombination } from '@reducers/selectors/loads/actions';


const LoadSelector = props => (
  <div className="calculation">
    <section className="list-type">
      {props.loadsTabMode === loadsTabModes.DESIGN &&   
       <Tooltip content={APP_TOOLTIPS.TOOLTIP_DESIGN_LOADS.Content}>
        <select
          className="form-control select__wide"
          value={props.selectedCombination}
          disabled={
            props.loadCombinations === null ||
            props.loadCombinations.filter(c => c.isSelected).length <= 1
          }
          onChange={e => {
            props.setDesignValue(e.target.value);
            if (e.target.value !== "Decisive") {
              let loadIdx = props.loadCombinations.findIndex(c => c.name === e.target.value);
              if (loadIdx >= 0) {
                props.setActiveCombination(loadIdx);
              }
            }
          }}
        >     
          <option value="Decisive" key="-1">{APP_TEXTS.LOAD_SEELECTOR_DECISIVE_COMBINATION.Content}</option>
               
          {props.loadCombinations && props.loadCombinations.map((c) => (
            c.isSelected && (
              <option value={c.name} key={c.name + Date.now}>{c.name}</option>
            )
          ))}
        </select>
        </Tooltip> 
      }

      {props.loadsTabMode === loadsTabModes.CHARACTERISTICS &&
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_DESIGN_LOADS.Content}>
        <select
          className="form-control select__wide"
          onChange={e => props.setCharacteristicsValue(e.target.value)}
        >
          <option>
            {props.calculateDesignLoadData.deadLoad.partialSafetyFactor}&#8729;G +
            {props.calculateDesignLoadData.liveLoad.partialSafetyFactor}&#8729;Q +
            {props.calculateDesignLoadData.temporaryLoad.partialSafetyFactor}&#8729;W
          </option>
        </select>
        </Tooltip>
      }
    </section>
  </div>
);

const mapState = state => ({
  selectedCombination: state.selectors.design[APP_TYPES.GENERAL_CALCULATION].loads.design,
  loadCombinations: state.selectors.loads[APP_TYPES.GENERAL_CALCULATION].designLoadingData,
  loadsTabMode: state.selectors.loads[APP_TYPES.GENERAL_CALCULATION].loadsTabMode,
  calculateDesignLoadData: state.selectors.loads[APP_TYPES.GENERAL_CALCULATION].calculateDesignLoadData,
  appStatus: state.main.status // use it as a hack to render a potential language change
});

const mapDispatch = dispatch => ({
  setDesignValue: value => dispatch(setDesignLoadsDesignValue(value)),
  setCharacteristicsValue: value => dispatch(setDesignLoadsCharacteristicsValue(value)),
  setActiveCombination: value => dispatch(setActiveCombination(value))
});

export default connect(mapState, mapDispatch)(LoadSelector);



// WEBPACK FOOTER //
// ./src/views/Design/components/GeneralCalculationDesign/LoadSelector.js